export const FRIEND_STATUS = "FRIEND_STATUS";

export function friendStatus(data) {
	return {
		type: FRIEND_STATUS,
		payload: data,
	};
}